import type { IMenuItem } from "InterfacesTypes/interfaces";

interface DropdownMenuProps {
  menuClassName?: string;
  itemClassName?: string;
  items: IMenuItem[];
}

const DropdownMenu: React.FC<DropdownMenuProps> = ({
  menuClassName = "",
  itemClassName = "",
  items,
}) => {
  //const items = useSelector(selectNavItems);

  return (
    <div className="relative">
      <div className={`${menuClassName}`} role="menu" aria-orientation="vertical">
        {items
          //.filter(item => item.ParentId == null)
          .map(item => (
            <a
              key={item.ID}
              // href={item.Link?.Url || "#"}
              href={item.Href || "#"}
              className={`text-white! hover:bg-[#003d4c] no-underline! ${itemClassName}`}
              role="menuitem"
              rel="noopener noreferrer"
            >
              {item.Title}
            </a>
          ))}
        {/* <Link
          to="/howTo"
          className={`text-white! hover:bg-[#003d4c] no-underline! ${itemClassName}`}
          role="menuitem"
        >
          Informationsägare
        </Link> */}
      </div>
    </div>
  );
};

export default DropdownMenu;